export const SET_USER_PROFILE_CONTENT_HEIGHT = 'SET_USER_PROFILE_CONTENT_HEIGHT'
